module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_wrap unit"
  }, [_c('NavTab'), _vm._v(" "), _c('div', {
    staticClass: "search-box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.getUnitList.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "select-wrap"
  }, [_c('div', {
    staticClass: "group margin-right-15"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("单位名称")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.model.organizationName),
      expression: "model.organizationName",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入单位名称"
    },
    domProps: {
      "value": (_vm.model.organizationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "organizationName", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "group situation margin-right-15 searchArrow"
  }, [_c('span', {
    staticClass: "left"
  }, [_vm._v("所属区域")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.provinceCode),
      callback: function($$v) {
        _vm.provinceCode = $$v
      },
      expression: "provinceCode"
    }
  }, _vm._l((_vm.provinceList), function(item) {
    return _c('el-option', {
      key: item.areaCode,
      attrs: {
        "label": item.areaName,
        "value": item.areaCode
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.onSelectCity
    },
    model: {
      value: (_vm.cityCode),
      callback: function($$v) {
        _vm.cityCode = $$v
      },
      expression: "cityCode"
    }
  }, _vm._l((_vm.cityList), function(item) {
    return _c('el-option', {
      key: item.areaCode,
      attrs: {
        "label": item.areaName,
        "value": item.areaCode
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.model.areaId),
      callback: function($$v) {
        _vm.$set(_vm.model, "areaId", $$v)
      },
      expression: "model.areaId"
    }
  }, _vm._l((_vm.areaList), function(item) {
    return _c('el-option', {
      key: item.areaCode,
      attrs: {
        "label": item.areaName,
        "value": item.areaCode
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "group btn-box"
  }, [_c('button', {
    staticClass: "btn margin-left-0",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.detailBox
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteConfirm(_vm.deleteId)
      }
    }
  }, [_vm._v("删除")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "table_wrap"
  }, [_c('div', {
    staticClass: "table_layout"
  }, [_c('div', {
    staticClass: "table_scroll"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataTabel,
      "max-height": "534",
      "border": "",
      "cell-style": _vm.cellStyle,
      "header-cell-style": _vm.tableHeaderColor
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "单位名称",
      "prop": "fullName",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "简称",
      "prop": "simpName",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "组织机构代码",
      "prop": "organizationCode",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属区域",
      "min-width": "120",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(scope.row.provinceName) + _vm._s(scope.row.cityName)), (scope.row.areaName) ? _c('span', [_vm._v(_vm._s(scope.row.areaName))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "排序号",
      "prop": "indexNo",
      "min-width": "80",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "100",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "primary pointer mr15",
          on: {
            "click": function($event) {
              return _vm.editUnitData(scope.row.id)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('span', {
          staticClass: "primary pointer mr15",
          on: {
            "click": function($event) {
              return _vm.deleteConfirm(scope.row.id)
            }
          }
        }, [_vm._v("删除")]), _vm._v(" "), _c('span', {
          staticClass: "primary pointer mr15",
          on: {
            "click": _vm.staffLink
          }
        }, [_vm._v("人员管理")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.dataTabel.length) ? _c('div', {
    staticClass: "pagination"
  }, [_c('nt-pagination', {
    ref: "child",
    on: {
      "fetchData": _vm.getUnitList
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.detailShow) ? _c('detail', {
    attrs: {
      "unitData": _vm.unitData
    },
    on: {
      "detailShowData": _vm.detailShowData,
      "getUnitList": _vm.getUnitList
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8bb56ec","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/unitManagement/list.vue
// module id = ccYY
// module chunks = 6